import { Indicator, Root } from '@radix-ui/react-checkbox';
import clsx from 'clsx';
import type { ComponentProps, FunctionComponent } from 'react';

import { IconCheckmark1Small } from '../icons';

export type CheckboxProps = ComponentProps<typeof Root> & {
    readonly className?: string;
    readonly disabled?: boolean;
};

export const Checkbox: FunctionComponent<CheckboxProps> = ({ className, disabled = false, ...props }) => {
    return (
        <Root
            className={clsx(
                'inline-flex items-center justify-center h-[16px] w-[16px]',
                'bg-transparent border-[1.5px] border-border-control rounded-xs',
                'cursor-pointer transition-all duration-150 ease-in-out',
                'focus-visible:outline-2 focus-visible:outline-focus-ring-soft focus-visible:outline-offset-2',
                'data-[state=checked]:bg-control-selected data-[state=checked]:border-0',
                'disabled:cursor-default disabled:opacity-50',
                className,
            )}
            disabled={disabled}
            {...props}
        >
            <Indicator className="flex items-center justify-center text-on-control-selected [&_svg]:h-[12px] [&_svg]:w-[12px]">
                <IconCheckmark1Small />
            </Indicator>
        </Root>
    );
};
